import React, { useEffect, useState } from 'react'
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
  List, ListItem, ListItemText, IconButton, CircularProgress,
} from '@mui/material'
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import {
  listPortfolioFileBuildingShares, removePortfolioFileBuildingShare,
} from 'services/portfolioDocumentsService'
import { toast } from 'react-toastify'

export default function PortfolioFileBuildingSharesModal({ portfolioId, file, canEdit, onChanged, onClose }) {
  const [shares, setShares] = useState([])
  const [loading, setLoading] = useState(true)

  const load = () => {
    setLoading(true)
    return listPortfolioFileBuildingShares(portfolioId, file.id)
      .then((res) => setShares(res.data.data || []))
      .catch(() => toast.error('Could not load the Building Passports this document is in'))
      .finally(() => setLoading(false))
  }

  useEffect(() => { load() }, [])

  const remove = async (shareId) => {
    try {
      await removePortfolioFileBuildingShare(portfolioId, file.id, shareId)
      await load()
      onChanged && onChanged()
    } catch (e) {
      toast.error('Could not remove the document from that Building Passport')
    }
  }

  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>In {shares.length} Building Passport{shares.length === 1 ? '' : 's'}</DialogTitle>
      <DialogContent dividers>
        {loading && <div style={{ padding: 16, textAlign: 'center' }}><CircularProgress size={20} sx={{ color: '#D24724' }} /></div>}
        {!loading && shares.length === 0 && <p style={{ color: '#888' }}>Not added to any Building Passports.</p>}
        {!loading && shares.length > 0 && (
          <List dense>
            {shares.map((s) => (
              <ListItem key={s.id} secondaryAction={canEdit && (
                <IconButton edge="end" size="small" title="Remove from this Building Passport" onClick={() => remove(s.id)}>
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              )}>
                <ApartmentOutlinedIcon style={{ fontSize: 18, color: '#888', marginRight: 10 }} />
                <ListItemText primary={s.name || 'Building Passport'} />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}
